import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetEmailTemplate, GetEmailTemplateResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";

const getData = (response?: SWRResponse<GetEmailTemplateResponse, GetEmailTemplateResponse>) => response?.data?.template;
const getError = (response?: SWRResponse<GetEmailTemplateResponse, GetEmailTemplateResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetEmailTemplateResponse, GetEmailTemplateResponse>) => ({});

const useGetEmailTemplate = (query?: Partial<GetEmailTemplate>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetEmailTemplate(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetEmailTemplate;